export { default as WorkdayConfiguration } from './WorkdayConfiguration/WorkdayConfiguration';
export const WorkdayConfigurationDynamic = () => import('./WorkdayConfiguration/WorkdayConfiguration');
export { default as McpIntegration } from './McpIntegration/McpIntegration';
export const McpIntegrationDynamic = () => import('./McpIntegration/McpIntegration');
